import { render, staticRenderFns } from "./RbuSectionFluctuationModule.vue?vue&type=template&id=016008b8"
import script from "./RbuSectionFluctuationModule.vue?vue&type=script&lang=js"
export * from "./RbuSectionFluctuationModule.vue?vue&type=script&lang=js"
import style0 from "./RbuSectionFluctuationModule.vue?vue&type=style&index=0&id=016008b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports